// extracted by mini-css-extract-plugin
module.exports = {"dragOverlay":"styles_dragOverlay__2sG7k","attachmentHeaderText":"styles_attachmentHeaderText__qvl3x","scale":"styles_scale__1welr"};